<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraAgencia />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraAgencia from "../Components/Leituras/LeituraAgencia.vue";
export default {
  name: "ReadReserve",
  components: {
    LeituraAgencia,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>